import { useMapState } from '../states.ts'
// biome-ignore lint/correctness/noPrivateImports: This is meant to be imported here
import { xwiPalette } from './xwiPalette.ts'

type MapPaletteOptions = typeof mapPaletteLight

const mapPaletteLight = {
	alerts: {
		alarm: xwiPalette.red[600],
		warning: xwiPalette.orange[500],
		info: xwiPalette.yellow[600],
		clear: xwiPalette.grey[700],
	},
	mapGeometry: {
		defaultFill: 'rgba(20, 22, 25, 0.2)',
		defaultStroke: 'rgba(20, 22, 25, 1)',
		selectedFill: 'rgba(18, 101, 218, 0.2)',
		selectedStroke: 'rgba(18, 101, 218, 1)',
		labelFill: '#222',
		labelStroke: '#fff',
	},
	reportCoverageBoundary: { stroke: xwiPalette.grey[700], text: xwiPalette.grey[700] },
	distanceTool: { stroke: xwiPalette.grey[900] },
	mapMarker: { bg: xwiPalette.grey[900], fg: xwiPalette.grey[100] },
	mapCoordinate: { bg: xwiPalette.grey[900], fg: xwiPalette.common.white, hover: xwiPalette.grey[800] },
}

const mapPaletteDark: MapPaletteOptions = {
	alerts: {
		alarm: xwiPalette.red[600],
		warning: xwiPalette.orange[500],
		info: xwiPalette.yellow[600],
		clear: xwiPalette.grey.A100,
	},
	mapGeometry: {
		defaultFill: 'rgba(255, 255, 255, 0.2)',
		defaultStroke: 'rgba(255, 255, 255, 1)',
		selectedFill: 'rgba(155, 198, 248, 0.2)',
		selectedStroke: 'rgba(155, 198, 248, 1)',
		labelFill: '#fff',
		labelStroke: '#222',
	},
	reportCoverageBoundary: { stroke: xwiPalette.grey[200], text: xwiPalette.grey[200] },
	distanceTool: { stroke: xwiPalette.grey[50] },
	mapMarker: { bg: xwiPalette.grey[200], fg: xwiPalette.grey[900] },
	mapCoordinate: { bg: xwiPalette.grey[50], fg: xwiPalette.common.black, hover: xwiPalette.grey[100] },
}

const mapPaletteSatellite: MapPaletteOptions = {
	alerts: {
		alarm: xwiPalette.red[600],
		warning: xwiPalette.orange[500],
		info: xwiPalette.yellow[600],
		clear: xwiPalette.grey.A100,
	},
	mapGeometry: {
		defaultFill: 'rgba(255, 255, 255, 0.2)',
		defaultStroke: 'rgba(255, 255, 255, 1)',
		selectedFill: 'rgba(155, 198, 248, 0.2)',
		selectedStroke: 'rgba(155, 198, 248, 1)',
		labelFill: '#fff',
		labelStroke: '#222',
	},
	reportCoverageBoundary: { stroke: xwiPalette.grey[200], text: xwiPalette.grey[200] },
	distanceTool: { stroke: xwiPalette.grey[50] },
	mapMarker: { bg: xwiPalette.grey[200], fg: xwiPalette.grey[900] },
	mapCoordinate: { bg: xwiPalette.grey[50], fg: xwiPalette.common.black, hover: xwiPalette.grey[100] },
}

const mapPalettes = {
	light: mapPaletteLight,
	dark: mapPaletteDark,
	satellite: mapPaletteSatellite,
}

export const useMapTheme = () => {
	const mapStyle = useMapState((s) => s.mapStyle)
	return mapPalettes[mapStyle] || mapPalettes.light
}
